<template>
  <b-container class="edit-team">
    <div id="team">
      <h1 class="title">{{ addOrEdit }} Team</h1>
      <div id="alerts">
        <b-alert
          :show="dismissCountDown"
          dismissible
          variant="success"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
          >You have successfully edited this team!</b-alert
        >
        <b-alert :show="showError" dismissible variant="warning"
          >Something went Wrong. Please refresh and try again.</b-alert
        >
      </div>
      <b-row>
        <b-col>
          <active-input plural="teams" singular="team"></active-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h4 class="sub-title">Basic Information</h4>
          <div class="basic-team-info mt-4">
            <b-form-team>
              <label for="team-name">Team Name:</label>
              <b-form-input type="text" v-model="team_name"></b-form-input>
            </b-form-team>
            <b-form-team>
              <label for="description">Team Description:</label>
              <b-form-textarea
                type="text"
                name="description"
                v-model="description"
              ></b-form-textarea>
            </b-form-team>
            <team-coordinator :parent= "addOrEdit"></team-coordinator>
          </div>
        </b-col>
        <b-col>
          <h4 class="sub-title">Geographic Information</h4>
          <geo-info
            plural="teams"
            parent="team"
            singular="team"
            :coords="false"
          ></geo-info>
        </b-col>
      </b-row>
      <b-row></b-row>
      <b-row>
        <b-col>
          <team-dates></team-dates>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h4 class="sub-title m-4">Team Trainers</h4>
          <team-trainers></team-trainers>
        </b-col>
      </b-row>
      <br />
      <confirm-submit></confirm-submit>
      <b-button
        :size="'lg'"
        :variant="'primary'"
        class="app_team_btn mb-4"
        @click.prevent="submitData"
        :disabled="isDisabled"
        >{{ addOrEdit }} Team</b-button
      >
    </div>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex';
import ConfirmSubmit from '../components/ConfirmSubmit';
import GeoInfo from '../components/GeoInfo';
import TeamCoordinator from '../components/TeamCoordinator';
import ActiveInput from '../components/ActiveInput';
import TeamTrainers from '../components/TeamTrainers';
import TeamDates from '../components/TeamDates';
import { flash } from '@/mixins/flashes';
import { scrollTo } from '@/mixins/scrollTo';

export default {
  name: 'EditTeam',
  mixins: [flash, scrollTo],
  components: {
    ConfirmSubmit,
    GeoInfo,
    ActiveInput,
    TeamTrainers,
    TeamCoordinator,
    TeamDates,
  },
  data() {
    return {
      isDisabled: false,
    };
  },
  methods: {
    ...mapActions({
      GET_ONE_TEAM: 'teams/GET_ONE_TEAM',
      UPDATE_TEAM: 'teams/UPDATE_TEAM',
      CREATE_TEAM: 'teams/CREATE_TEAM',
      RESET_TEAMS_STATE: 'teams/RESET_TEAMS_STATE',
    }),
    async submitData() {

      if (this.$route.params && this.$route.params.id) {
        await this.UPDATE_TEAM();
        window.scrollTo(0, 0);
        this.flashSuccess();
        this.$store.commit('resetConfirmed');
        this.RESET_TRAINERS_STATE();
        setTimeout(() => {
          this.$router.push('/teams');
        }, 1500);
      } else {
        if (!this.team_name.length) {
          alert('please add a team name');
          return;
        }
        await this.CREATE_TEAM();
        window.scrollTo(0, 0);
        this.$store.commit('resetConfirmed');
        this.flashSuccess();
        this.RESET_TEAMS_STATE();
      }
    },
  },
  stopClick() {},
  computed: {
    addOrEdit() {
      return this.$route.path.includes('/add') ? 'Add a ' : 'Edit ';
    },
    team_name: {
      get() {
        return this.$store.state.teams.team.team_name;
      },
      set(val) {
        this.$store.commit('teams/team_name', val);
      },
    },
    description: {
      get() {
        return this.$store.state.teams.team.description;
      },
      set(val) {
        this.$store.commit('teams/description', val);
      },
    },
  },
  created() {
    this.RESET_TEAMS_STATE();
  },
  mounted() {
    if (!this.$route.path.includes('/add')) {
      this.GET_ONE_TEAM();
    }
  },
  destroyed() {
    this.RESET_TEAMS_STATE();
  },
};
</script>

<style scoped>
#edit-team {
  width: 98%;
  white-space: nowrap;
  margin: 0 auto;
  text-align: center;
}
form input,
.form div {
  margin: 20px;
}
.app_team_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 520px;
  border: none;
  cursor: pointer;
}
div.col {
  margin: 1%;
  padding: 1%;
  border: 1px solid gray;
  box-shadow: 3px 2px 2px #b2b2b2;
}
</style>
